import { useEffect } from 'react';
import { useStore } from '@nanostores/react';
import { chatId } from '~/lib/persistence';
import { capturePaywallBlock, showPlans, usePlanAccess } from '~/lib/planGate';

/**
 * The Code tab for a free user: the code stays behind the plan, the same rule
 * as "Download code" (export-eligibility.ts) — and the server refuses the file
 * tree to free users too, so this is the explanation, not the lock itself.
 *
 * Opening the tab counts as a paywall view, like the Publish panel's locked
 * banner, so "nobody wanted the code" and "nobody opened the tab" stay apart.
 */
export function CodeLockedPanel() {
  const currentChatId = useStore(chatId);
  const { tier } = usePlanAccess();

  useEffect(() => {
    capturePaywallBlock('view_code', { tier, chatId: currentChatId });
    // once per opening of the tab
  }, []);

  return (
    <div className="flex h-full w-full items-center justify-center p-8">
      <div className="flex max-w-[380px] flex-col items-center gap-3 text-center">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/5">
          <span className="i-ph:lock-simple text-[20px] text-muted" />
        </span>
        <div className="text-[15px] font-medium text-primary">Your code is on paid plans</div>
        <p className="m-0 text-[13px] leading-relaxed text-muted">
          Viewing and downloading your project's code needs a plan. Your site keeps working, and you can keep editing it
          in the chat.
        </p>
        <button type="button" className="ui-btn-primary mt-1" onClick={() => showPlans('view_code')}>
          See plans
        </button>
      </div>
    </div>
  );
}
